import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import NotificationDialog from './components/NotificationDialog';
import { selectUser } from '../store/userSlice';

const PriceSetterNotification = () => {
  const user = useSelector(selectUser);
  const [showSignInDialog, setShowSignInDialog] = useState(false);

  useEffect(() => {
    if (!user || !user.uid) {
      setShowSignInDialog(true);
    } else {
      setShowSignInDialog(false);
    }
  }, [user]);

  return (
    <NotificationDialog
      open={showSignInDialog}
      message="Please sign in to make trades."
      onClose={() => setShowSignInDialog(false)}
    />
  );
};

export default PriceSetterNotification;
